
import { Validators } from "@angular/forms"
import { ActionInterface, ACTIONS_BASE } from "./actions.constants"
import { FormField, ColumnNames } from "./form.constants"
import { DEFAULT_PAGINATE_OPTIONS_LIST, PaginateOptions } from "../utils/paginate.utils"

export const MATERIAS_COLUMN_NAMES: ColumnNames[] = [
  { name: "codigo", label: "Cód. Materia" },
  { name: "descripcion", label: "Descripción" },
  { name: "nivel", label: "Nivel" },
  { name: "modalidad", label: "Modalidad" },
  { name: "deleted_at", label: "Fecha Baja", pipe: "date" },
  { name: "observacion", label: "Observación" },
]
export const MATERIAS_COLUMN_NAMES_DETAIL: ColumnNames[] = [
  { name: "codigo", label: "Cód. Materia" },
  { name: "descripcion", label: "Descripción" },
  { name: "nivel.descripcion", label: "Nivel" },
  { name: "deleted_at", label: "Fecha Baja", pipe: "date" },
  { name: "observacion", label: "Observación" },
]
export const MATERIAS_COLUMN_NAMES_COMPACT: ColumnNames[] = [
  { name:"codigo",label:"Cód" },
  { name:"descripcion",label:"Materia" }
]
export const MATERIAS_PLAN_COLUMN_NAMES: ColumnNames[] = [
  { name: "materia.codigo", label: "Cód. Materia" },
  { name: "materia.descripcion", label: "Descripción"},
  { name: "deleted_at", label: "Fecha Baja", pipe: "date" },
  { name: "observacion", label: "Observación" },
]

export const MATERIAS_FIELDS_CONFIG: { [field: string]: FormField } = {
  descripcion: {
    label: 'Descripción',
    type: 'text',
    position: 1,
  },
  caracter: {
    label: 'Carácter',
    type: 'text',
    position: 2,
  },
  observacion: {
    label: 'Observación',
    type: 'text',
    position: 2,
  },
}
export const MATERIAS_FIELDS_FORM_CREATE : {[name: string]:FormField} = {
  codigo: {
    label: 'Cód. Materia',
    type: 'text',
    position: 1,
    validations: [Validators.required]
  },
  descripcion: {
    label: 'Descripción',
    type: 'text',
    position: 2,
    validations: [Validators.required]
  },
  modalidad_id: {
    label: 'Modalidad',
    type: 'select',
    position: 3,
    validations: [Validators.required]
  },
  plan_id: {
    label: 'Plan',
    type: 'select',
    position: 3,
    validations: [Validators.required]
  }
}
export const MATERIAS_FIELDS_FORM_EDIT : {[name: string]:FormField} = {
  codigo: {
    label: 'Cód. Materia',
    type: 'text',
    position: 1,
    validations: [Validators.required]
  },
  descripcion: {
    label: 'Descripción',
    type: 'text',
    position: 2,
    validations: [Validators.required]
  },
  nivel_id: {
    label: 'Nivel',
    type: 'select',
    position: 3,
    validations: [Validators.required]
  },
  observacion: {
    label: 'Observacion',
    type: 'text',
    position: 4,
  }
}
export const MATERIAS_ACTIONS: { [name: string]: ActionInterface } =
{
  "eliminarMateria": {
    icon:"delete",
    traslation:"Dar de baja",
    url:'materias',
    type:'modal',
    tittle:'Eliminar Materia',
    templateName:'modalDelete'
  },
  "titulosAsociados": {
    icon:"assignment",
    traslation:"Títulos Asociados",
    url:'materias',
    type:'modal',
    tittle:'Títulos Asociados',
    templateName:'modalTitulosVinculados',
    showActionsButtons:false
  },
  edit : {
    traslation:'Editar',
    icon:"edit",
    url:'edit',
    type:'link'
  },
  view : {
    traslation:'Detalle',
    icon:"visibility",
    url:'view',
    type:'link'
  },
}
export const MATERIAS_ACTIONS_POR_PLAN: { [name: string]: ActionInterface } =
{
  delete: ACTIONS_BASE["delete"]
}
export const MATERIAS_ADDED_ACTIONS: { [name: string]: ActionInterface } =
{
  "delete": {
    icon: "delete",
    traslation: "Eliminar",
    type: 'customFunction'
  }
}

export const MATERIAS_POR_PLAN_ACTIONS_DELETED: { [name: string]: ActionInterface } = {
  restore : {
    traslation:'Restaurar',
    icon:"restore_from_trash",
    type:'modal',
  },
};

export const MATERIAS_PAGINATION_OPTIONS_DEFAULT:PaginateOptions = {
  ...DEFAULT_PAGINATE_OPTIONS_LIST,
  order:'materia.descripcion'
}
export const MATERIAS_POR_PLAN_PAGINATE_OPTIONS:PaginateOptions = {
  ...DEFAULT_PAGINATE_OPTIONS_LIST,
  order:'materia.descripcion'
}



